import AppLogoIcon from '@/components/app-logo-icon';
import { Toaster } from '@/components/ui/sonner';
import { cn } from '@/lib/utils';
import { type SharedData } from '@/types';
import { usePage } from '@inertiajs/react';
import { type PropsWithChildren } from 'react';

interface AuthLayoutProps {
    title?: string;
    description?: string;
    containerClassName?: string;
    withAppName?: boolean;
}

export default function AuthSplitLayout({
    children,
    title,
    description,
    withAppName = true,
    containerClassName,
}: PropsWithChildren<AuthLayoutProps>) {
    const { name, quote } = usePage<SharedData>().props;

    return (
        <>
            <Toaster richColors />
            <div className="relative grid h-dvh flex-col items-center justify-center px-8 sm:px-0 lg:max-w-none lg:grid-cols-2 lg:px-0">
                <div className="bg-foreground relative hidden h-full flex-col justify-center overflow-hidden p-10 text-white lg:flex dark:border-r">
                    {/* <Link href={route('home')} className="relative z-20 flex items-center text-lg font-medium">
                    <AppLogoIcon className="mr-2 size-8 fill-current text-white" />
                    AmplifyKit
                </Link> */}
                    <img
                        src="/promo-image.webp"
                        alt="AmplifyKit"
                        className="aspect-auto h-[90vh] w-full translate-x-20 rounded-lg object-cover object-left"
                    />
                    {/* {quote && (
                    <div className="relative z-20 mt-auto">
                        <blockquote className="space-y-2">
                            <p className="text-lg">&ldquo;{quote.message}&rdquo;</p>
                            <footer className="text-sm text-neutral-300">{quote.author}</footer>
                        </blockquote>
                    </div>
                )} */}
                </div>
                <div className="w-full py-8 lg:p-8">
                    <div className={cn('mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]', containerClassName)}>
                        <span className="relative z-20 flex items-center justify-center gap-2">
                            <AppLogoIcon className="h-10 w-10 fill-current text-black sm:h-12 sm:w-12" />
                            {withAppName && <span className="text-lg font-medium">AmplifyKit</span>}
                        </span>
                        <div className="flex flex-col items-center gap-2 text-center">
                            <h1 className="text-xl font-medium">{title}</h1>
                            <p className="text-muted-foreground text-sm text-balance">{description}</p>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
}
